import React from 'react';
import {
  getPublishedTime,
  getFileStateText,
  getStatusIcon,
  getUploadedText,
} from '../../views/Settings/settings.utils';
import {
  Container,
  DeleteAllDataContentWrapper,
  DeleteAllText,
  DownloadConfirmContainer,
  DownloadConfirmText,
  DownloadConfirmItalicText,
  DownloadConfirmTextAgree,
  IconWrapper,
  FileName,
  FileStatus,
  Left,
  PublishedInfo,
  Right,
} from './FileRow.styles';
import {
  IAutoClassificationFileStatus,
  IFileData,
  IFileDataType,
} from '../../utils/types';
import { ApButtonIcon, ApIcon, colors } from '@alixpartners/ui-components';
import ConfirmationDialog from '../ConfirmDialog/ConfirmDialog';
import ConfirmDownloadDialog from '../ConfirmDialog/ConfirmDownloadDialog';
import { getFile } from 'utils/api';
import { downloadAsFile } from 'utils/download';

export const FileRow = ({
  file,
  isDownloadDisabled = false,
  isDeleteDisabled = false,
  onDeleteFile,
}: {
  file: IFileData;
  isDownloadDisabled?: boolean;
  isDeleteDisabled?: boolean;
  onDeleteFile: any;
}) => {
  const {
    actionDate,
    actorFullName,
    autoClassificationStatus,
    fileName,
    fileState,
    id,
  } = file;
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
  const [isDownloadFileOpen, setIsDownloadFileOpen] = React.useState(false);
  const [isConfirmDisabled, setIsConfirmDisabled] = React.useState(false);
  return (
    <Container>
      <Left>
        <IconWrapper>
          {file.fileDataType === IFileDataType.PRODUCTS ? (
            <ApIcon iconName="outline_done" iconColor={colors.grey8} />
          ) : (
            getStatusIcon({ status: fileState, autoClassificationStatus })
          )}
        </IconWrapper>
        <FileName
          disabled={isDownloadDisabled}
          onClick={() => {
            !isDownloadDisabled && setIsDownloadFileOpen(true);
          }}
          title={fileName}
        >
          {fileName}
        </FileName>
        <FileStatus>
          {file.fileDataType !== IFileDataType.PRODUCTS &&
            `(${getFileStateText({
              status: fileState,
              autoClassificationStatus,
            })})`}
        </FileStatus>
      </Left>
      <Right>
        <PublishedInfo>
          {getUploadedText(fileState)} {actorFullName}{' '}
          {getPublishedTime(actionDate)}
        </PublishedInfo>
        <ApButtonIcon
          disabled={
            isDeleteDisabled ||
            autoClassificationStatus ===
              IAutoClassificationFileStatus.IN_PROGRESS
          }
          iconName="delete"
          iconProps={{
            iconColor: colors.grey6,
          }}
          onClick={() => !isDeleteDisabled && setIsDeleteDialogOpen(true)}
        />
        <ConfirmDownloadDialog
          confirmText="download file"
          isOpen={isDownloadFileOpen}
          title="Are you sure you want to download this file?"
          message={
            <DownloadConfirmContainer>
              <DownloadConfirmText>
                To download this file you must:
              </DownloadConfirmText>
              <DownloadConfirmItalicText>
                - Secure and protect your data
              </DownloadConfirmItalicText>
              <DownloadConfirmItalicText>
                - Only share this file with authorized parties
              </DownloadConfirmItalicText>
              <DownloadConfirmItalicText>
                - Delete it from your local drives after it is no longer useful
              </DownloadConfirmItalicText>
              <DownloadConfirmTextAgree>
                By clicking "Download File" you acknowledge and agree to fulfill
                your obligations listed above.
              </DownloadConfirmTextAgree>
            </DownloadConfirmContainer>
          }
          onClose={() => setIsDownloadFileOpen(false)}
          isConfirmDisabled={isConfirmDisabled}
          onConfirm={() => {
            setIsConfirmDisabled(true);
            getFile(id).then(
              ({
                fileName,
                fileUrl,
              }: {
                fileName: string;
                fileUrl: string;
              }) => {
                downloadAsFile(fileUrl, fileName);
                setIsConfirmDisabled(false);
                setIsDownloadFileOpen(false);
              }
            );
          }}
        />
        <ConfirmationDialog
          confirmText="delete"
          isOpen={isDeleteDialogOpen}
          title="Delete file"
          message={
            <DeleteAllDataContentWrapper>
              <DeleteAllText>
                Are you sure you want to delete <strong>{fileName}</strong>?
              </DeleteAllText>
            </DeleteAllDataContentWrapper>
          }
          onClose={() => setIsDeleteDialogOpen(false)}
          onConfirm={() => {
            onDeleteFile(id);
          }}
        />
      </Right>
    </Container>
  );
};
